const AMENITIES_DESCRIPTIONS = {
    'wireless_internet': {
        es: 'Internet inalámbrico',
        en: 'Wireless internet',
        order: 1,
        icon: 'icons-internet',
        highlited: false
    },
    'internet': {
        es: 'Internet',
        en: 'Internet',
        order: 1,
        icon: 'icons-internet',
        highlited: false
    },
    'high_speed_wifi': {
        es: 'Internet inalámbrico de alta velocidad',
        en: 'High-speed WiFi',
        order: 1,
        icon: 'icons-internet',
        highlited: false
    },
    'beach': {
        es: 'Playa',
        en: 'Beach',
        order: 2,
        icon: 'icons-beach-club',
        highlited: false
    },
    'parking': {
        es: 'Estacionamiento',
        en: 'Parking',
        order: 3,
        icon: 'icons-parking',
        highlited: false
    },
    'beach_club': {
        es: 'Club de playa',
        en: 'Beach club',
        order: 2,
        icon: 'icons-beach-club',
        highlited: false
    },
    'pool': {
        es: 'Piscina',
        en: 'Pool',
        order: 4,
        icon: 'icons-pool1',
        highlited: false
    },
    'fitness_center': {
        es: 'Gimnasio',
        en: 'Fitness center',
        order: 5,
        icon: 'icons-fitness-center',
        highlited: false
    },
    'spa': {
        es: 'Spa',
        en: 'Spa',
        order: 6,
        icon: 'icons-spa',
        highlited: false
    },
    'spa_services': {
        es: 'Servicios de spa',
        en: 'Spa services',
        order: 6,
        icon: 'icons-spa',
        highlited: false
    },
    'childrens_area': {
        es: 'Área para niños',
        en: 'Children\'s area',
        order: 7,
        icon: 'icons-childrens-club',
        highlited: false
    },
    'childrens_club': {
        es: 'Club de niños',
        en: 'Children\'s club',
        order: 7,
        icon: 'icons-childrens-club',
        highlited: false
    },
    'childrens_activities': {
        es: 'Actividades para niños',
        en: 'Children\'s activities',
        order: 7,
        icon: 'icons-childrens-club',
        highlited: false
    },
    'accessible_rooms': {
        es: 'Habitaciones para personas con discapacidad',
        en: 'Accessible rooms',
        order: 8,
        icon: 'icons-accessible-rooms',
        highlited: false
    },
    'pets': {
        es: 'Acepta Mascotas',
        en: 'Pets accepted',
        order: 9,
        icon: 'icons-pets',
        highlited: false
    }
};

export { AMENITIES_DESCRIPTIONS };